import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { FileService } from 'src/app/services/file.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-company-vendor-files-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './company-vendor-files-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CompanyVendorFilesGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private FileService: FileService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'CompanyVendorFile';
    this.rowModelType = 'serverSide';
    this.suppressFieldDotNotation = false;

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.FileService.getCompanyVendorFiles(queryObject),
          this.FileService.getCompanyVendorFileCount(countQueryObject)
        ]).subscribe({
          next: ([CompanyVendorFiles, companyVendorFileCount]) => {
            params.success({
              rowData: CompanyVendorFiles,
              rowCount: companyVendorFileCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
